/* Nemira — don't restore the old scroll position, and don't yank the reader either.

   Setting scrollRestoration to manual is enough on its own: the browser simply
   stops putting a returning or reloading visitor back where they were. The
   earlier version also forced scrollTo(0,0) on DOMContentLoaded, on load and
   again at 250ms - and "load" fires after every image, so anyone who had begun
   reading got dragged back to the top. That was a second jump, not a fix. */
(function () {
  'use strict';
  if (!('scrollRestoration' in history)) return;
  try { history.scrollRestoration = 'manual'; } catch (e) {}
})();
